import { PointsWithCashPipe } from './points-with-cash.pipe';

export const POINTSWITHCASH_PIPE_DECLARATIONS = [PointsWithCashPipe];

export * from './points-with-cash.pipe';
